'use strict';

module.exports = {
    getUrl: Odigeo._.constant(Odigeo.Settings.getProperty('membershipServiceFormatter')('create-basic-free-account')),

    getMethod: Odigeo._.constant('POST'),

    requestSuccess(data) {
        Odigeo.trigger(`${this.widget.id}:createBasicFreeAccountOk`, data);
    },

    requestError() {
        Odigeo.trigger(`${this.widget.id}:createBasicFreeAccountFail`);
    },

    formatData(request) {
        return JSON.stringify({
            userId: request.userId,
            email: request.email,
            name: request.name,
            lastNames: request.lastNames,
            monthsToRenewal: request.monthsToRenewal,
            membershipType: request.membershipType,
            balance: request.balance,
            channel: request.channel,
            recaptchaResponse: request.recaptchaResponse,
        });
    },
};
